import { Widgets } from 'shared/presenters/graphqlTypes'

// Extract main variables from widgetData
const determineCategorySettings = (widgetData: Widgets) => {
  // Verify if should filter by categories, if false it will show a link to all activities
  const filterByCategory = widgetData?.filter_by_category

  // All categories created by the outlet
  const categoriesData = widgetData?.outlet?.categories

  // Only renders categories assigned to show on this widget id
  const widgetCategoryIds = widgetData?.categories_widgets?.map(item => {
    return item.category.id
  })

  // Check if the widget requested to only show specific categories
  const hasWidgetCategories = widgetData?.categories_widgets?.length > 0

  return {
    filterByCategory,
    categoriesData,
    widgetCategoryIds,
    hasWidgetCategories
  }
}

export default determineCategorySettings
